import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { ImportFileCsvCreate } from 'src/app/interfaces/importFileCsvCreate';
import { ImportFileXlsxCreate } from 'src/app/interfaces/importFileXlsxCreate';
import { ApplicationService } from '../application.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { MatStepper, MatStep, MatStepLabel, MatStepperNext } from '@angular/material/stepper';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { FormulaireComponent } from '../../formulaire/formulaire.component';

@Component({
  selector: 'mic-app-import-file-xlsx-modal',
  templateUrl: './import-file-xlsx-modal.component.html',
  styleUrls: ['./import-file-xlsx-modal.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatDivider,
    MatStepper,
    MatStep,
    ReactiveFormsModule,
    MatStepLabel,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    MatStepperNext,
    MatTabGroup,
    MatTab,
    FormulaireComponent
  ]
})
export class ImportFileXlsxModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ImportFileXlsxModalComponent>>(MatDialogRef);
  private readonly formBuilder = inject(FormBuilder);
  private readonly appService = inject(AppService);
  private readonly applicationService = inject(ApplicationService);

  selected = 'primary';
  sheetNumber: number[] = [];
  sheets: ImportFileCsvCreate[] = [];
  displayFormulaire: boolean;
  importFileXlsx: ImportFileXlsxCreate = {
    name: '',
    importFileCsvCreates: []
  };

  ngOnInit(): void {
    this.appService.sheets.subscribe((res) => {
      this.sheets.push(res);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onClose(): void {
    this.dialogRef.close();
  }
  step1 = this.formBuilder.group({
    value: ['', Validators.required]
  });
  step3 = this.formBuilder.group({
    value: ['', Validators.required]
  });

  onSubmit() {
    this.importFileXlsx.name = this.step1.value.value;
    this.importFileXlsx.importFileCsvCreates = this.sheets;
    this.applicationService.addFunctionImportFileXlsx(this.importFileXlsx).subscribe(() => {
      this.dialogRef.close();
    });
  }

  addSheet() {
    this.sheetNumber.push(this.sheetNumber[this.sheetNumber.length - 1] + 1);
  }
}
